// src/App.js
import { Routes, Route, Navigate } from "react-router-dom";

/** ----------------------------- RENTER PAGES ----------------------------- **/
import Home from "./Pages/Home";
import Explore from "./Pages/Explore";
import ListingDetail from "./Pages/ListingDetail";
import Checkout from "./Pages/Checkout";
import BookingSuccess from "./Pages/BookingSuccess";
import Trips from "./Pages/Trips";
import Messages from "./Pages/Messages";
import Account from "./Pages/Account";
import NotFound from "./Pages/NotFound";

/** -------------------------------- GUARDS -------------------------------- **/
import RoleGuard from "./components/RoleGuard";

/** ------------------------------- HOST AREA ------------------------------ **/
import HostLayout from "./host/HostLayout";
import HostDashboard from "./host/HostDashboard";
import HostListings from "./host/HostListings";
import CreateListing from "./host/CreateListing";
import EditListing from "./host/EditListing";
import HostCalendar from "./host/HostCalendar";
import HostBookings from "./host/HostBookings";
import HostPayouts from "./host/HostPayouts";
import HostSettings from "./host/HostSettings";

// Check-in & access page
import HostAccess from "./host/HostAccess";

/** --------------------------------- ADMIN -------------------------------- **/
import AdminGuard from "./admin/AdminGuard";
import AdminLayout from "./admin/AdminLayout";
import AdminDashboard from "./admin/AdminDashboard";
import AdminListings from "./admin/AdminListings";
import AdminRevenue from "./admin/AdminRevenue";
import VerificationQueue from "./admin/VerificationQueue";
import AdminBookings from "./admin/AdminBookings";
import AdminReliability from "./admin/AdminReliability";

// ✅ NEW: Hosts dashboard (aggregate host profiles + their listings)
import AdminHostsDashboard from "./admin/AdminHostsDashboard";

/** --------------------------------- LEGAL -------------------------------- **/
import LegalHostTerms from "./Pages/LegalHostTerms";

export default function App() {
  return (
    <Routes>
      {/* --------------------------- Public / Renter --------------------------- */}
      <Route path="/" element={<Home />} />
      <Route path="/explore" element={<Explore />} />
      <Route path="/listing/:id" element={<ListingDetail />} />
      <Route path="/checkout/:id" element={<Checkout />} />
      <Route path="/booking-success" element={<BookingSuccess />} />
      <Route path="/account" element={<Account />} />

      {/* ------------------------------ Legal pages --------------------------- */}
      <Route path="/legal/host-terms" element={<LegalHostTerms />} />

      {/* -------------------- Auth-required (no specific role) ---------------- */}
      <Route
        path="/trips"
        element={
          <RoleGuard>
            <Trips />
          </RoleGuard>
        }
      />
      <Route
        path="/messages"
        element={
          <RoleGuard>
            <Messages />
          </RoleGuard>
        }
      />

      {/* ------------------------------ Host app ------------------------------ */}
      <Route
        path="/host/*"
        element={
          <RoleGuard mustHaveRole="host">
            <HostLayout />
          </RoleGuard>
        }
      >
        <Route index element={<HostDashboard />} />
        <Route path="listings" element={<HostListings />} />
        <Route path="listings/new" element={<CreateListing />} />
        <Route path="listings/edit/:id" element={<EditListing />} />
        <Route path="calendar" element={<HostCalendar />} />
        <Route path="bookings" element={<HostBookings />} />
        <Route path="access" element={<HostAccess />} />
        <Route path="payouts" element={<HostPayouts />} />
        <Route path="settings" element={<HostSettings />} />

        {/* convenience redirect for any old link like /host/new */}
        <Route path="new" element={<Navigate to="listings/new" replace />} />
      </Route>

      {/* ---------------------------- Convenience ----------------------------- */}
      <Route path="/switch-to-host" element={<Navigate to="/host" replace />} />

      {/* ------------------------------ Admin app ----------------------------- */}
      <Route
        path="/admin/*"
        element={
          <AdminGuard>
            <AdminLayout />
          </AdminGuard>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="listings" element={<AdminListings />} />
        <Route path="hosts" element={<AdminHostsDashboard />} />
        <Route path="verifications" element={<VerificationQueue />} />
        <Route path="bookings" element={<AdminBookings />} />
        <Route path="revenue" element={<AdminRevenue />} />
        <Route path="reliability" element={<AdminReliability />} />

        {/* Optional: old/alias redirect if you ever rename routes */}
        {/* <Route path="customers" element={<Navigate to="hosts" replace />} /> */}
      </Route>

      {/* -------------------------------- 404 --------------------------------- */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
